import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { PeFormQuestionType } from '../../enums/pe-form-question-type.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'peFormQuestionType',
  standalone: false
})
export class PeFormQuestionTypePipe implements PipeTransform {
  public transform(value: PeFormQuestionType): string {
    return getPeFormQuestionType(value);
  }
}

export function getPeFormQuestionType(value: PeFormQuestionType): string {
  switch (value) {
    case PeFormQuestionType.Input:
      return 'Comment Box';
    case PeFormQuestionType.Score:
      return 'Score';
    case PeFormQuestionType.Radio:
      return 'Radio';
    default:
      throw new Error(`Unsupported value for PeFormQuestionType: ${value}.`);
  }
}

export function getPeFormQuestionTypeList(): IdName[] {
  return enumToList(PeFormQuestionType, getPeFormQuestionType);
}
